export const cardLookup = (cardName) => {
    switch(cardName){
        case "spades_ace":
            return `https://d1u9hkaasftir6.cloudfront.net/65777e4bf3e55914957c7b26/65777e4cf3e55914957c7b29/cardfronts/spades_ace_simple.png`
        default:
            return `https://d1u9hkaasftir6.cloudfront.net/65777e4bf3e55914957c7b26/65777e4cf3e55914957c7b29/cardfronts/${cardName}.png`
    }
}

